import { render, staticRenderFns } from "./de_stage-6.vue?vue&type=template&id=50dbbafe&scoped=true&"
import script from "./de_stage-6.vue?vue&type=script&lang=js&"
export * from "./de_stage-6.vue?vue&type=script&lang=js&"
import style0 from "./de_stage-6.vue?vue&type=style&index=0&id=50dbbafe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dbbafe",
  null
  
)

component.options.__file = "de_stage-6.vue"
export default component.exports